export default __webpack_public_path__ + "static/media/pic.37ebf463.jpeg";